import React from 'react';

import {Policy, PolicySpec} from 'auth/PolicyConstants';
import {setWindowTitle} from 'BenchlingUtil';
import {PolicyTemplateNode} from 'graphql-client/__generated/graphqlGlobalTypes';

import PolicyEditor from './PolicyEditor';

interface Props {
  policy: Omit<Policy, 'isHidden'>;
  initialSpec: PolicySpec;
  listingsTitle: string;
  policiesURL: string;
  policyTemplate: PolicyTemplateNode;
  updatePolicy: (updatedSpec: PolicySpec) => Promise<PolicySpec | null>;
}

export default function PolicyPage(props: Props): JSX.Element {
  const [initialSpec, setInitialSpec] = React.useState(props.initialSpec);
  const [spec, setSpec] = React.useState(props.initialSpec);

  const _handleSaveChanges = async (): Promise<void> => {
    const updatedSpec = await props.updatePolicy(spec);
    if (updatedSpec) {
      setInitialSpec(updatedSpec);
      setSpec(updatedSpec);
    }
  };

  const _handleUpdate = (specUpdate: Partial<PolicySpec>): void => {
    setSpec({...spec, ...specUpdate});
  };

  React.useEffect(() => {
    setWindowTitle(`${props.policy.name} - Access Policies`);
  }, [props.policy]);

  return (
    <PolicyEditor
      policy={props.policy}
      spec={spec}
      initialSpec={initialSpec}
      onUpdateSpec={_handleUpdate}
      onSaveSpec={_handleSaveChanges}
      isWritable={props.policy.permissions.writable}
      listingsTitle={props.listingsTitle}
      policiesURL={props.policiesURL}
      policyTemplate={props.policyTemplate}
    />
  );
}
